// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoPanel_container__29-mH","title":"InfoPanel_title__3HaJj","expanded":"InfoPanel_expanded__2xA45","content":"InfoPanel_content__vsh4Y"};